import React, { useCallback, useState } from 'react';
import { AlignEnum, Button, ColorNameEnum, SizeEnum, Text, WeightEnum } from '@getvim/atomic-ui';
import { LoginWidgetWrapper } from '../../templates/login-widget-wrapper';
import lockSvg from '../../../resources/images/lock.svg';
import './index.less';
import { SeamlessConsentInfo } from '../../molecules/seamless-consent-info';

export interface ApprovalWidgetProps {
  onApproved: () => void;
  onDenied: () => void;
  onClose: () => void;
  onLearnMoreVisibilityChanged: (visible: boolean) => void;
  showDifferentMethods: boolean;
  signupAppName: string | undefined;
}

export const ApprovalWidget: React.FC<ApprovalWidgetProps> = ({
  onApproved,
  onDenied,
  onClose,
  onLearnMoreVisibilityChanged,
  showDifferentMethods,
  signupAppName,
}) => {
  const [learnMoreVisible, setLearnMoreVisibility] = useState(false);
  const showLearnMore = useCallback(() => {
    setLearnMoreVisibility(true);
    onLearnMoreVisibilityChanged(true);
  }, [onLearnMoreVisibilityChanged, setLearnMoreVisibility]);
  const hideLearnMore = useCallback(() => {
    setLearnMoreVisibility(false);
    onLearnMoreVisibilityChanged(false);
  }, [onLearnMoreVisibilityChanged, setLearnMoreVisibility]);

  return (
    <LoginWidgetWrapper className="approval-widget" onCloseClicked={onClose}>
      {learnMoreVisible ? (
        <SeamlessConsentInfo goBack={hideLearnMore} />
      ) : (
        <>
          <Text
            className="consent-title"
            weight={WeightEnum.normal}
            align={AlignEnum.left}
            colorName={ColorNameEnum.theme}
          >
            Login to Vim
            {signupAppName && (
              <>
                <br />
                to start using <b>{signupAppName}</b>
              </>
            )}
          </Text>
          <div className="consent-details">
            <Text
              size={SizeEnum['16px']}
              colorName={ColorNameEnum.theme}
              align={AlignEnum.left}
              weight={WeightEnum.semibold}
            >
              Auto login?
            </Text>

            <Text size={SizeEnum['14px']} colorName={ColorNameEnum.theme} align={AlignEnum.left}>
              To verify your identity, Vim will use the certificate issued by your EHR, every time
              you login to your EHR.
            </Text>
            <Text size={SizeEnum['14px']} colorName={ColorNameEnum.theme} align={AlignEnum.left}>
              We never store or save your certificate.
            </Text>
          </div>
          <img src={lockSvg} alt="lock" className="lock-img" />
          <Button className="learn-more" buttonType="link" color="gray" onClick={showLearnMore}>
            <Text size={SizeEnum['14px']} underline>
              Learn more
            </Text>
          </Button>
          <div className="approval-actions">
            <Button buttonType="small" width="block" onClick={onApproved}>
              <Text size={SizeEnum['18px']}>Auto login</Text>
            </Button>
            {showDifferentMethods && (
              <>
                <div className="or-separator">
                  <span className="divider" />
                  <Text size={SizeEnum['14px']}>Or</Text>
                  <span className="divider" />
                </div>
                <Button
                  className="deny-button"
                  buttonType="outline"
                  width="block"
                  bgColor="white"
                  onClick={onDenied}
                >
                  <Text size={SizeEnum['18px']} weight={WeightEnum.semibold}>
                    Choose another login method
                  </Text>
                </Button>
              </>
            )}
          </div>
        </>
      )}
    </LoginWidgetWrapper>
  );
};
